import gql from 'graphql-tag';

export const QUERY = gql([
    `
query FindLandingAppointmentContent
{
  queryLandingAppointmentContents {
    data {
      pageTitle: createPageTitle { iv }

      titleBlocTitle: titleBlocTitle2 { iv }
      titleBlocSubTitle: titleBlocSubTitle2 { iv }
      titleBlocFontSizeTitle: titleBlocFontSizeTitle2 { iv }
      titleBlocFontSizeSubTitle: titleBlocFontSizeSubTitle2 { iv }
      titleBlocWidth: titleBlocWidth2 { iv }
      titleBlocTagline: titleBlocTagline2 { iv }
      titleBlocTextColor: titleBlocTextColor2 { iv }
      titleBlocColor: titleBlocColor2 { iv }
      titleBlocPicture: titleBlocPicture2 {
        iv {
          url
          fileSize
        }
      }
      titleBlocHorizontalPosition: titleBlocHorizontalPosition2 { iv }
      titleBlocVerticalPosition: titleBlocVerticalPosition2 { iv }
      titleBlocJustification: titleBlocJustification2 { iv }

      mention { iv }
      mentionFontSize { iv }
      mentionTextColor { iv }
    }
  }
} 
`,
]);
